import { AfterViewInit, ChangeDetectionStrategy, Component, OnInit, ViewChild } from "@angular/core";
import { VERSION } from '../../../environments/version';

import { AlertService } from "@app/modules/alert";
import { StatisticsService } from "@app/services/statistics.service";
import { IStatisticsDateRange, IStatisticsGeneral, IMonthlySummary, IStatisticsStatus, IClosedSummary, IProjectStatistics } from "@app/models/statistics";
import { FormControl } from "@angular/forms";
import { GlobalService } from "@app/services/global.services";
import { NgxSpinnerService } from "ngx-spinner";
import { MatTableDataSource } from "@angular/material/table";
import { MatTableExporterDirective } from "mat-table-exporter";
import { MatPaginator } from "@angular/material/paginator";


@Component({
    selector: "app-statistics",
    templateUrl: "./statistics.component.html",
    styleUrls: ["./statistics.component.scss"],
    changeDetection: ChangeDetectionStrategy.Default,
})
export class StatisticsComponent implements AfterViewInit, OnInit {
    @ViewChild("monthlySummaryPaginator") monthlySummaryPaginator: MatPaginator;
    @ViewChild("closedSummaryPaginator") closedSummaryPaginator: MatPaginator;
    @ViewChild("submittedSummaryPaginator") submittedSummaryPaginator: MatPaginator;    
    @ViewChild("monthlySummaryExporter") monthlySummaryExporter: MatTableExporterDirective;
    @ViewChild("closedSummaryExporter") closedSummaryExporter: MatTableExporterDirective;
    @ViewChild("submittedSummaryExporter") submittedSummaryExporter: MatTableExporterDirective;

    appVersion = VERSION;
    loginDisplay = false;

    options = {
        autoClose: false,
        keepAfterRouteChange: false,
    };
    stats : IStatisticsGeneral = {
        activeInProgress: 0,
        activeInternalReview: 0,
        activeSubmitted: 0,
        submittedRequests: 0,
        inProgressStarted: 0,
        internalReviewStarted: 0,
        closedRequests: 0,
        submittedConsultations: 0,
        submittedWorkOrders: 0,
        submittedProjects: 0,
        closedConsultations: 0,
        closedWorkOrders: 0, 
        closedProjects: 0,
        activeProjects: 0,
    };
    statusStatistics : IStatisticsStatus[];
    statusValues: any[] = [];
    totalWorkRequests: 0;

    fromDate = new FormControl();
    toDate = new FormControl();
    overallStatusData : any[] = [];
    overallRequestData : any[] = [];

    periodStatsData : any[] = [];
    projectPeriodStats :IProjectStatistics;
    activePeriodStatsData : any[] = [];
    periodRequestTypeData : any[] = [];
    periodRequestTypeStats : any[] = [];

    monthlySummary :  MatTableDataSource<IMonthlySummary>;
    closedSummary :  MatTableDataSource<IClosedSummary>;
    submittedSummary: MatTableDataSource<IClosedSummary>;

    chartCustomColors: any[] = [];

    //-------------
    
  // options

  SUBMISSION_MONTHS = 12

  submissionSummary: any[] = [];
  ss_view  : [number, number]= [1150, 300];
  ss_legend: boolean = true;
  ss_showLabels: boolean = true;
  ss_animations: boolean = true;
  ss_xAxis: boolean = true;
  ss_yAxis: boolean = true;
  ss_showYAxisLabel: boolean = true;
  ss_showXAxisLabel: boolean = true;
  ss_xAxisLabel: string = 'Year / Month';
  ss_yAxisLabel: string = 'Submissions';
  ss_timeline: boolean = false;

  colorScheme = {
    domain: ['#5AA454', '#E44D25', '#CFC0BB', '#7aa3e5', '#a8385d', '#aae3f5']
  };

  //---------------
    
    tablePageSize = 25;
    tablePageSizeOptions = [10, 25, 50, 100];
    exportTablePageSize = 500;
    currentPageSize = this.tablePageSize;
    displayedColumns = [
        "monthStr",
        "month",
    ];
    displayedClosedSummaryColumns = [
        "monthStr",
        "month",
    ];
    displayedSubmittedSummaryColumns = [
        "monthStr",
        "month",
    ];
    constructor(
        public alertService: AlertService,
        private statisticsService : StatisticsService,
        private globalService : GlobalService,
        private spinner: NgxSpinnerService,
    ) {
        this.getStats();
    }

    ngOnInit(): void {
        this.toDate.setValue(new Date());
        this.chartCustomColors  = [
            { name: "Submitted", value: '#085696' },
            { name: "In Progress", value: 'green' },
            { name: "In Progress Initiated", value: 'green' },
            { name: "Internal Review", value: '#996300' },
            { name: "Internal Review Initiated", value: '#996300' },
            { name: "Closed", value: 'black' },
    
        ]
    }
    ngAfterViewInit() {
       this.setupSortAndFilters();
    }

    setupSortAndFilters() {
        this.monthlySummary.paginator = this.monthlySummaryPaginator;
        this.closedSummary.paginator = this.closedSummaryPaginator;
        this.submittedSummary.paginator = this.submittedSummaryPaginator;

        this.displayedColumns = [
            "year",             
            "monthStr",
            "requestType",
            "submitted",
            "internalReview",
            "inProgress",
            "closed",
      
    ]
    this.displayedClosedSummaryColumns = [
        "year",             
        "monthStr",
        "requestType",
        "count",
        "avgDaysToReview",
        "maxDaysToReview",
        "avgDaysToInProgress",
        "maxDaysToInProgress",
        "avgDaysToClosed",
        "maxDaysToClosed" 
    ]
    this.displayedSubmittedSummaryColumns = [
        "year",             
        "monthStr",
        "requestType",
        "count",

    ]
    }
    getStats() {
        this.monthlySummary = new MatTableDataSource<IMonthlySummary>();
        this.closedSummary = new MatTableDataSource<IClosedSummary>();
        this.submittedSummary = new MatTableDataSource<IClosedSummary>();
        
        this.periodRequestTypeData = [];
        this.periodRequestTypeStats = [];
        this.getPeriodStats();
        this.getProjectPeriodStats();
        this.getOverallStats();
        this.getOverallRequestTypes();
        this.getMonthlySummary();
        this.getClosedSummary();
        //this.getSubmittedSummary();

    }


    getPeriodStats() {
        this.spinner.show();
        this.activePeriodStatsData = [];
        
        this.periodStatsData = [];
        const dates: IStatisticsDateRange = {};
        if (this.fromDate.value != null) {
            dates.fromDate = this.globalService.getFormattedDateYYYMMDD(this.fromDate.value);
        }
        if (this.toDate.value != null) {
            dates.toDate =  this.globalService.getFormattedDateYYYMMDD(this.toDate.value);
        }
        this.statisticsService.getGeneralStatistics(dates).subscribe({
            next: (data: any) => {
                this.stats = data;
                this.activePeriodStatsData=  [
                    {"name": "Submitted", "value" : this.stats.activeSubmitted},
                    {"name": "Internal Review", "value" : this.stats.activeInternalReview},
                    {"name": "In Progress", "value" : this.stats.activeInProgress}
                ]; 
                this.periodStatsData =  [
                    {"name": "Submitted", "value" : this.stats.submittedRequests},
                    {"name": "Internal Review Initiated", "value" : this.stats.internalReviewStarted},
                    {"name": "In Progress Initiated", "value" : this.stats.inProgressStarted},
                    {"name": "Closed", "value" : this.stats.closedRequests}
                ]; 

                this.periodRequestTypeData = [... this.periodRequestTypeData, {"name": "Submitted Work Orders", "value" : this.stats.submittedWorkOrders}];
                this.periodRequestTypeData = [... this.periodRequestTypeData, {"name": "Closed Work Orders", "value" : this.stats.closedWorkOrders}];
                this.periodRequestTypeData = [... this.periodRequestTypeData, {"name": "Submitted Consultations", "value" : this.stats.submittedConsultations}];
                this.periodRequestTypeData = [... this.periodRequestTypeData, {"name": "Closed Consultations", "value" : this.stats.closedConsultations}];
                


                //this.periodRequestTypeData =  [
                //    {"name": "Submitted Work Orders", "value" : this.stats.submittedWorkOrders},
                //    {"name": "Closed Work Orders", "value" : this.stats.closedWorkOrders},
                //    {"name": "Submitted Consultations", "value" : this.stats.submittedConsultations},
                //    {"name": "Closed Consultations", "value" : this.stats.closedConsultations},
                   // {"name": "Submitted Projects", "value" : this.stats.submittedProjects},
                  //  {"name": "Closed Projects", "value" : this.stats.closedProjects},
                   // {"name": "Active Projects", "value" : this.stats.activeProjects}
                //]

                this.spinner.hide();
            }
            ,error: (err) => {
                console.error(err);
                this.spinner.hide();
            }       
        });
    }

    getProjectPeriodStats() {

        const dates: IStatisticsDateRange = {};
        if (this.fromDate.value != null) {
            dates.fromDate = this.globalService.getFormattedDateYYYMMDD(this.fromDate.value);
        }
        if (this.toDate.value != null) {
            dates.toDate =  this.globalService.getFormattedDateYYYMMDD(this.toDate.value);
        }
        this.statisticsService.getProjectStatistics(dates).subscribe({
            next: (data: any) => {
                this.projectPeriodStats = data;
 
                    this.periodRequestTypeData = [... this.periodRequestTypeData, {"name": "Started Projects", "value" : this.projectPeriodStats.startedProjects}];
                    this.periodRequestTypeData = [... this.periodRequestTypeData, {"name": "Closed Projects", "value" : this.projectPeriodStats.closedProjects}];
                    this.periodRequestTypeData = [... this.periodRequestTypeData, {"name": "Active Projects", "value" : this.projectPeriodStats.activeProjects}];


                    //this.periodRequestTypeData.push({"name": "Started Projects", "value" : this.projectPeriodStats.startedProjects});
                    //this.periodRequestTypeData.push({"name": "Closed Projects", "value" : this.projectPeriodStats.closedProjects});
                    //this.periodRequestTypeData.push({"name": "Active Projects", "value" : this.projectPeriodStats.activeProjects});

             }
            ,error: (err) => {
                console.error(err);
                this.spinner.hide();
            }       
        });
    }


    getOverallStats() {
        this.totalWorkRequests =0;
        this. overallStatusData = [];
        this.statisticsService.getStatusStatistics().subscribe({
            next: (data: any) => {
                this.statusStatistics = data;
                for (const stat of data) {
                    this.totalWorkRequests += stat.count;
                    this. overallStatusData = [...this. overallStatusData, {"name": stat.status, "value" : stat.count}];
                }

            }
            ,error: (err) => {
                console.error(err);
            }       
        });
    }
    getOverallRequestTypes() {
        this.overallRequestData = [];
        this.statisticsService.getRequestTypeStatistics().subscribe({
            next: (data: any) => {
                for (const stat of data) {
                    this.overallRequestData = [...this.overallRequestData, {"name": stat.requestType, "value" : stat.count}];
                }

            }
            ,error: (err) => {
                console.error(err);
            }       
        });
    }
    getMonthlySummary() {
   
        this.monthlySummary.data = [];
        this.statisticsService.getMonthlySummaryStatistics().subscribe({
            next: (rows: IMonthlySummary[]) => {
               this.monthlySummary.data  = [...this.monthlySummary.data, ...rows]; //new MatTableDataSource(rows);
               this.monthlySummary.data.sort((a, b) => ((a.year.toString()+a.month.toString()+a.requestType) > (b.year.toString()+b.month.toString()+b.requestType) ? -1 : 1))
               this.submissionSummary = [];
               let cutOffMonth = this.subtractMonths(new Date(), this.SUBMISSION_MONTHS);
                for (let row of this.monthlySummary.data) {
                    if ((row.year * 100 + row.month) > (cutOffMonth.getFullYear() *100 + cutOffMonth.getMonth())) {
                        let fnd = this.submissionSummary.find(o => o.name === row.requestType);
                        if (fnd) {
                            fnd.series.push({ 'sort': row.year + "/" + row.month.toString().padStart(2, '0'), 'name':  row.monthStr + " (" + row.year + ")" , 'value': row.submittedRequests })
                            fnd.series.sort((a: { sort: string; }, b: { sort: any; }) => ((a.sort > (b.sort) ? -1 : 1)));
                        } else {
                            let n = { 'name': row.requestType, 'series': [{ 'sort': row.year + "/" + row.month.toString().padStart(2, '0'),'name': row.monthStr + " (" + row.year + ")", 'value': row.submittedRequests }] }
                            this.submissionSummary.push(n);
                        }
                    }
               }    
               this.submissionSummary.sort((a, b) => ((a.year.toString()+a.month.toString()+a.requestType) > (b.year.toString()+b.month.toString()+b.requestType) ? -1 : 1))
               console.log(this.submissionSummary);   
            }
            ,error: (err) => {
                console.error(err);
            }       
        });
    }

    subtractMonths = (date: Date, months: number): Date => {
        const result = new Date(date);
        result.setMonth(result.getMonth() - months);
        return result;
    };

    getClosedSummary() {
   
        this.closedSummary.data = [];
        this.statisticsService.getClosedSummaryStatistics().subscribe({
            next: (rows: IClosedSummary[]) => {
               this.closedSummary.data  = [...this.closedSummary.data, ...rows]; //new MatTableDataSource(rows);

            }
            ,error: (err) => {
                console.error(err);
            }       
        });
    }   
     
    exportMonthlyData(format: any) {
        this.spinner.show();
        this.monthlySummaryExporter.exportTable(format, {
            fileName: "IT_Work_Requests_Monthly_Summary_" + new Date().toISOString().slice(0, 10)      
        });
    }
    exportClosedData(format: any) {
        this.spinner.show();
        this.closedSummaryExporter.exportTable(format, {
            fileName: "IT_Work_Requests_Closed_Summary_" + new Date().toISOString().slice(0, 10)   
               
        });
    }
    /**
    * event when export is  completed.  reset the display
    */
        exportCompleted() {
            this.spinner.hide();
        }
}
